// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1KPX2","col":"Table_col__1I886","fulfillmentStatus":"Table_fulfillmentStatus__2nvYL","emailCol":"Table_emailCol__2W5Nh"};